import { render, staticRenderFns } from "./OutstandingInvoices.vue?vue&type=template&id=56bd80a4&scoped=true"
import script from "./OutstandingInvoices.vue?vue&type=script&lang=js"
export * from "./OutstandingInvoices.vue?vue&type=script&lang=js"
import style0 from "./OutstandingInvoices.vue?vue&type=style&index=0&id=56bd80a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd80a4",
  null
  
)

export default component.exports